import React from 'react';
import { useSelector } from 'react-redux';

import CrmIframe from '@swf/components/CrmZone/components/CrmIframe/CrmIframe';
import withWidgetTestId from '@swf/core/hoc/withWidgetTestId';
import type { WidgetFC } from '@swf/core/types/Widget';
import Promotion from '@swf/sports/components/Promotion/Promotion';

import styles from './SportsPromotionWidget.scss';
import { sportsPromotionWidgetModel, useSportsPromotionWidget } from './model';

const SportsPromotionWidget: WidgetFC = () => {
  const { widgetSelect } = useSportsPromotionWidget();
  const promotion = useSelector(widgetSelect.promotion);
  const hasErrored = useSelector(widgetSelect.hasErrored);

  if (!promotion || hasErrored) return null;

  return (
    <div className={styles.wrapper}>
      <Promotion>
        <CrmIframe html={promotion} dynamicHeight data-testid="crm-sports-promotion" />
      </Promotion>
    </div>
  );
};

SportsPromotionWidget.model = sportsPromotionWidgetModel;

export default withWidgetTestId(SportsPromotionWidget, 'sports-promotion');
